
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/invideo-vs-capcut-social-clips-vs-filmmaking",
      function () {
        return require("private-next-pages/blog/invideo-vs-capcut-social-clips-vs-filmmaking.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/invideo-vs-capcut-social-clips-vs-filmmaking"])
      });
    }
  